import { ApplicationType } from '../../../candidate/config/model';

export const DELETE_ATTACHED_FILE = (uuid: string) => `application-attached-files/${uuid}`;
export const GET_APPLICATION_FILES_CONFIG = (applicationType: ApplicationType) =>
  `application-files-config/${applicationType}`;
